'use client'

import type { ReactNode } from 'react'
import { PanelsSurfaceProvider, type PanelsSkin, type PanelsSurface } from '@/deskUiSkeletons/Page/PanelsSurfaceContext'
import { MoreLink } from '@/deskUiSkeletons/Shared/Shared'
import { mainTemplateVariant, menuTemplateVariant } from '../rowTemplates/RowTemplateConfig'
import { HackernewsCheckedsInfo, HackernewsFoldSubsButton, HackernewsPagingBar, HackernewsRefreshSubs } from './HackernewsControls'

const hackernewsPanelsSkin: PanelsSkin = {
  toolbar: 'mb-4 flex min-h-4 items-center',
  toolbarHide: 'cursor-pointer rounded-full bg-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-300',
  toolbarMessage: 'hidden',
  panelAnswers: 'relative mb-8 flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm',
  panelSubmsges: 'relative mb-8 flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm',
  panelTools: 'mb-3 flex min-h-8 flex-wrap items-center gap-2',
  rootList: 'm-0 flex list-none flex-col bg-[#f6f6ef] p-2 text-sm',
  sectionInfo: 'mb-3 inline-flex w-max items-center rounded-full bg-violet-100 px-3 py-1.5 text-xs font-semibold text-violet-800',
  sectionInfoCount: 'ml-1',
  menuPanel: 'relative flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm',
  menuPanelShown: '!flex',
  menuPanelHidden: '!hidden',
  togglePhoto: 'hidden',
  menuPanelTools: 'mb-3 flex min-h-8 flex-wrap items-center gap-2',
  menuList: 'flex list-none flex-col gap-3 p-0 text-sm',
  sectionSwitch: 'mb-3 flex w-max gap-1 rounded-xl bg-slate-100 p-1 text-xs',
  sectionSwitchButton: 'rounded-lg px-3 py-2',
  sectionSwitchButtonActive: 'bg-violet-600 text-white',
  sectionSwitchButtonInactive: 'bg-transparent text-slate-600 hover:bg-white',
  menuEmpty: 'px-2 py-4 text-xs text-slate-400',
}

const hackernewsPanelsSurface: PanelsSurface = {
  FoldSubsButton: HackernewsFoldSubsButton,
  PagingBar: HackernewsPagingBar,
  RefreshSubs: HackernewsRefreshSubs,
  CheckedsInfo: HackernewsCheckedsInfo,
  MoreLink,
  menuEmptyLabel: 'No items',
  config: { mainTemplateVariant, menuTemplateVariant },
  skin: hackernewsPanelsSkin,
}

export function HackernewsPanelsSurfaceProvider({ children }: { children: ReactNode }) {
  return <PanelsSurfaceProvider value={hackernewsPanelsSurface}>{children}</PanelsSurfaceProvider>
}
